<template>
    <div class="relative" ref="wrapper">
        <button
            type="button"
            @click="open = !open"
            :class="buttonClass"
            class="flex items-center justify-between gap-1 text-left"
        >
            <span class="truncate">{{ modelValue }}</span>
            <svg class="w-4 h-4 shrink-0 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clip-rule="evenodd" />
            </svg>
        </button>

        <div
            v-if="open"
            class="absolute z-50 mt-1 w-64 bg-white border border-gray-200 rounded-lg shadow-lg"
            :class="dropdownPosition"
        >
            <div class="p-2 border-b border-gray-100">
                <input
                    ref="searchInput"
                    v-model="search"
                    type="text"
                    placeholder="Search..."
                    class="block w-full rounded border-gray-300 text-sm focus:border-gray-400 focus:ring-0 py-1.5 px-2.5"
                    @keydown.escape="open = false"
                />
            </div>
            <div class="max-h-48 overflow-y-auto py-1">
                <button
                    v-for="dc in filteredCodes"
                    :key="dc.alpha2"
                    type="button"
                    class="w-full text-left px-3 py-1.5 text-sm hover:bg-gray-50 flex justify-between items-center"
                    :class="{ 'bg-gray-50 font-medium': dc.dial_code === modelValue }"
                    @click="select(dc.dial_code)"
                >
                    <span class="truncate">{{ dc.name }}</span>
                    <span class="text-gray-500 ml-2 shrink-0">{{ dc.dial_code }}</span>
                </button>
                <div v-if="!filteredCodes.length" class="px-3 py-2 text-sm text-gray-400">
                    No results
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, nextTick, onMounted, onBeforeUnmount } from 'vue'

const props = defineProps({
    modelValue: { type: String, default: '' },
    dialCodes: { type: Array, default: () => [] },
    buttonClass: { type: [String, Array, Object], default: '' },
    dropdownPosition: { type: String, default: 'left-0' },
})

const emit = defineEmits(['update:modelValue'])

const open = ref(false)
const search = ref('')
const wrapper = ref(null)
const searchInput = ref(null)

const filteredCodes = computed(() => {
    if (!search.value) return props.dialCodes
    const q = search.value.toLowerCase()
    return props.dialCodes.filter(dc =>
        dc.name.toLowerCase().includes(q) || dc.dial_code.includes(q)
    )
})

const select = (dialCode) => {
    emit('update:modelValue', dialCode)
    open.value = false
    search.value = ''
}

watch(open, async (val) => {
    if (val) {
        await nextTick()
        searchInput.value?.focus()
    } else {
        search.value = ''
    }
})

const onClickOutside = (e) => {
    if (wrapper.value && !wrapper.value.contains(e.target)) {
        open.value = false
    }
}

onMounted(() => document.addEventListener('click', onClickOutside))
onBeforeUnmount(() => document.removeEventListener('click', onClickOutside))
</script>
